import { FC } from 'react';
import { HighlightIcon } from '@mews/b2b-ui';
import { Container, IconName, Stack, useToken } from '@optimus-web/core';

interface IconProps {
    icon: IconName;
}

export const LineIcon: FC<IconProps> = ({ icon }) => {
    const containerSize = useToken('sizing400');

    return (
        <Container width={`${containerSize}px`} height={`${containerSize}px`}>
            <Stack alignment="center" itemAlignment="center">
                <HighlightIcon size="small" icon={icon} />
            </Stack>
        </Container>
    );
};
